import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseDetailScreen from '../BaseDetailScreen';

import {
  fetchTransferCheckInstructions,
  fetchTransferWireInstructions,
} from '../../actions';

import './styles.css';

export const INSTRUCT_TYPE = Object.freeze({ WIRE: 'wire', CHECK: 'check' });

// From: https://www.folioinstitutional.com/advisorhelp/fund-account.jsp?q=3
const AcceptedChecks = () => (
  <div styleName="instructLabel">
    We accept the following types of checks
    <ul styleName="list">
      <li styleName="instructText">
        Personal checks made payable to Folio Investments, Inc. Checks must be drawn on an account
        in your name at a financial institution located in the U.S.
      </li>
      <li styleName="instructText">
        U.S. government checks or federal or state tax refund checks made payable to you
        and endorsed to Folio Investments, Inc.
      </li>
      <li styleName="instructText">
        Corporate checks drawn on an account at a financial institution located
        in the U.S., in the name of a corporation, and made payable to Folio Investments, Inc.
      </li>
    </ul>
    We do <strong>not</strong> accept the following types of deposits:
    <ul styleName="list">
      <li styleName="instructText">Cash</li>
      <li styleName="instructText">Temporary checks (starter checks)</li>
      <li styleName="instructText">Money orders</li>
      <li styleName="instructText">3rd party checks (e.g., a check endorsed by a third party to you)</li>
      <li styleName="instructText">Post-dated checks</li>
      <li styleName="instructText">Foreign checks payable in foreign funds</li>
      <li styleName="instructText">Traveler’s checks</li>
    </ul>
  </div>
);

const Address = ({ address }) => {
  const city = get(address, 'city', '');
  const country = get(address, 'country', '');
  const line1 = get(address, 'line1', '');
  const line2 = get(address, 'line2', '');
  const state = get(address, 'state', '');
  const zipcode = get(address, 'zipcode', '');
  return (
    <div styleName="instructBlock">
      <div styleName="instructText">{line1}</div>
      <div styleName="instructText">{line2}</div>
      <div styleName="instructText">{`${city}, ${state} ${zipcode}`}</div>
      <div styleName="instructText">{country}</div>
    </div>
  );
};

const getInstructions = (instructions, type) => {
  let comp;
  if (type === INSTRUCT_TYPE.CHECK) {
    const address = get(instructions, 'address', {});
    const payableTo = get(instructions, 'payableTo', '');
    const accountNumber = get(instructions, 'accountNumber', '');
    comp = (
      <div styleName="mainInstruct">
        <div styleName="instructLabel">Mail Checks To</div>
        <Address address={address} />
        <div styleName="instructLabel">Payable To</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{payableTo}</div>
        </div>
        <div styleName="instructLabel">Account Number</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{accountNumber}</div>
        </div>
        <AcceptedChecks />
      </div>
    );
  } else {
    const address = get(instructions, 'wireAddress', {});
    const wireAccountName = get(instructions, 'wireAccountName', '');
    const wireRoutingAbaNumber = get(instructions, 'wireRoutingAbaNumber', '');
    const wireAccountNumber = get(instructions, 'wireAccountNumber', '');
    const forFurtherCredit = get(instructions, 'forFurtherCredit', '');
    comp = (
      <div styleName="mainInstruct">
        <div styleName="instructLabel">Send Bank Wire Deposits To</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{wireAccountName}</div>
        </div>
        <div styleName="instructLabel">Bank Address</div>
        <Address address={address} />
        <div styleName="instructLabel">Routing / ABA Number</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{wireRoutingAbaNumber}</div>
        </div>
        <div styleName="instructLabel">Account Number</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{wireAccountNumber}</div>
        </div>
        <div styleName="instructLabel">Instructions / Message</div>
        <div styleName="instructBlock">
          <div styleName="instructText">{forFurtherCredit}</div>
        </div>
      </div>
    );
  }
  return comp;
};

class UnconnectedTransferInstructions extends Component {
  componentDidMount() {
    if (this.props.type === INSTRUCT_TYPE.CHECK) {
      this.props.fetchTransferCheckInstructions(this.props.currentAccount);
    } else {
      this.props.fetchTransferWireInstructions(this.props.currentAccount);
    }
  }
  render() {
    const {
      instructFetching,
      instructions,
      type,
      currentAccount,
    } = this.props;
    return (
      instructFetching ? null :
      <BaseDetailScreen
        pageHeading={`${type === INSTRUCT_TYPE.CHECK ? 'Check' : 'Wire'} Transfer Instructions`}
        backTo={`/transfers/${currentAccount}`}
        backLabel="Return to Transfer Funds"
      >
        {getInstructions(instructions, type)}
      </BaseDetailScreen>
    );
  }
}

UnconnectedTransferInstructions.propTypes = {
  type: PropTypes.string,
};

UnconnectedTransferInstructions.defaultProps = {
  type: INSTRUCT_TYPE.CHECK,
};

const mapStateToProps = (state, { match: { params: { type } } }) => ({
  currentAccount: state.currentAccount,
  instructions: get(state, 'instructions.data'),
  instructFetching: get(state, 'instructions.isFetching', true),
  type,
});

const mapDispatchToProps = {
  fetchTransferCheckInstructions,
  fetchTransferWireInstructions,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedTransferInstructions);



// WEBPACK FOOTER //
// ./src/components/TransferFunds/TransferInstructions.js